import type { ComplianceStatus, LegalReqType } from './types';

export const LEGAL_REQ_TYPE_LABEL: Record<LegalReqType, string> = {
  ley: 'Ley',
  decreto: 'Decreto',
  resolucion: 'Resolución',
  norma: 'Norma',
  permiso: 'Permiso',
  licencia: 'Licencia',
  otro: 'Otro',
};

export const COMPLIANCE_STATUS_LABEL: Record<ComplianceStatus, string> = {
  identificado: 'Identificado',
  evaluando: 'Evaluando',
  cumple: 'Cumple',
  no_cumple: 'No cumple',
  no_aplica: 'No aplica',
};

export function complianceStatusBadgeClass(status: ComplianceStatus): string {
  switch (status) {
    case 'cumple':
      return 'bg-green-100 text-green-800';
    case 'no_cumple':
      return 'bg-red-100 text-red-800';
    case 'evaluando':
      return 'bg-blue-100 text-blue-800';
    case 'no_aplica':
      return 'bg-slate-100 text-slate-800';
    case 'identificado':
    default:
      return 'bg-amber-100 text-amber-800';
  }
}

export function expiryStateBadgeClass(daysUntilDue: number): string {
  if (daysUntilDue < 0) return 'bg-red-100 text-red-800';
  if (daysUntilDue <= 7) return 'bg-amber-100 text-amber-800';
  return 'bg-slate-100 text-slate-800';
}

export function formatDaysUntilDue(days: number): string {
  if (days < 0) return `Vencido hace ${Math.abs(days)} día(s)`;
  if (days === 0) return 'Vence hoy';
  return `Vence en ${days} día(s)`;
}
